export type MaintenanceConfigResponse = Record<string, boolean>;

export enum MaintenanceConfigFeature {
  ONE_UPGRADE = 'disableOneUpgrade',
}
